export default __webpack_public_path__ + "static/media/fr-asia-8.9daa0f3e.jpg";